import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <AboutSection />
        <AppSection />
        <UpdatesSection />
        <CommentsSection />
        <ContactSection />
        <TopicsSection />
        <FAQSection />
        <IndexSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}